import { Box, CssBaseline } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const SuccessPage = () => {
  let params = useParams();
  let navigate = useNavigate();
  // const [searchParams, setSearchParams] = useSearchParams();
  // const q = searchParams.get("payment_intent");
  // const src = searchParams.get("payment_intent_client_secret");
  // const f = searchParams.get("redirect_status");

  useEffect(() => {
    setTimeout(() => navigate(`/`), 4000);
  }, []);

  const orderId = params.OrderId;
  const transactionId = params.ReferenceNumber;
  return (
    <Box sx={{ textAlign: "center" }}>
      <CssBaseline />
      <div className="card">
        <div className="checkmark-container">
          <i className="checkmark">✓</i>
        </div>
        <h1 onClick={() => navigate(`/`)}>Success</h1>
        <p>
          We received your purchase request;
          <br /> we'll be in touch shortly!
          {transactionId
            ? ` Your payment reference number is: ${transactionId}`
            : null}
        </p>
      </div>
    </Box>
  );
};
